import React from 'react';
import './styles.css';

function Footer(){

    return(
        <div className="row m-0 mt-4">
            <div className="main-cont col-12">
                <div className="col-12 col-lg-4 d-flex align-items-center mt-3" style={{flexDirection:"column"}}>
                    <div className="title-info text-info-footer">Dirección</div>
                    <div className="text-info-footer">Carrera 6 entre calles 9 y 10 Edificio Palacio de San Francisco</div>
                    <div style={{height:10}}></div>
                    <div className="title-info text-info-footer">Horario atención</div>
                    <div className="text-info-footer">Lunes a jueves: Mañana  7:30 am a 12:30 pm Tarde 1:30 pm a 5:30 pm Viernes:  Mañana 7:30 am a 12:30 pm  - Tarde 1:30 pm a 4:30 pm</div>
                </div>
                <div className="col-12 col-xl-4 d-flex align-items-center mt-3" style={{flexDirection:"column"}}>
                    <div className="title-info text-info-footer">Email</div>
                    <div className="text-info-footer">contactenos@valledelcauca.gov.co</div>
                    <div style={{height:10}}></div>
                    <div className="title-info text-info-footer">Notificaciones Judiciales</div>
                    <div className="text-info-footer">njudiciales@valledelcauca.gov.co</div>
                    <div className="text-info-footer">ntutelas@valledelcauca.gov.co</div>
                    <div className="text-info-footer">nconciliaciones@valledelcauca.gov.co</div>
                </div>
                <div className="col-12 col-xl-4 d-flex align-items-center mt-3" style={{flexDirection:"column"}}>
                    <div className="title-info text-info-footer">Call Center</div>      
                    <div className="text-info-footer">(57-2) 620 00 00</div>
                    <div style={{height:10}}></div>
                    <div className="title-info text-info-footer">Fax</div>
                    <div className="text-info-footer">886 0150 Línea Gratuita: 01-8000972033</div>
                </div>
            </div>
            <div className="col-12 d-flex" style={{alignItems:"center", flexDirection:"column", padding:20, background:"#222429"}}>
                <div style={{fontWeight:"bold", color:"white", textAlign:"center"}}>Políticas de seguridad de la información y Política de  tratamiento de Datos personales</div>
                <div style={{color:"white", textAlign:"center"}}>Última fecha de actualización: Jueves 11 de enero de 2024 10:00 am</div>
                <div style={{color:"white", textAlign:"center"}}>Todos los Derechos Reservados © 2024</div>
            </div>
        </div>
    );
}

export default Footer;
  